import { gql } from '@apollo/client'
import {
  BattleDemoLeaderboardFragment,
  BattleDemoLeaderboardRecordFragment
} from '@src/graphql/fragment/battleDemo'

export default gql`
  query GetBattleDemoSoloPvELeaderboard($input: GetLeaderboardInput!) {
    getDungeonLeaderboard(input: $input) {
      ...LeaderboardCommon
      recordInfo {
        ...LeaderboardRecordCommon
      }
    }
  }
  ${BattleDemoLeaderboardFragment}
  ${BattleDemoLeaderboardRecordFragment}
`
